import _ from "lodash";
import ResultBook from "./ResultBook";
import { useAppStore } from "stores/appStore";
import { useBookStore } from "stores/bookStore";
import { BOOK_TYPE_GD_KI_NANG_SO, BOOK_TYPE_SBT } from "consts/book";
import { isMobile } from "react-device-detect";

export default function SectionKiNangSo() {
  const grades = useAppStore((state) => state.grades);
  const books = useBookStore((state) => state.books);
  const gradeId = useAppStore((state) => state.gradeId);
  const subjectId = useAppStore((state) => state.subjectId);
  const booksOfCurrentSubject = _.get(books, [gradeId, subjectId], []);

  const sbtBooks = booksOfCurrentSubject.filter(
    (item) => item.book_type_id === BOOK_TYPE_GD_KI_NANG_SO
  );

  const currentGrade = grades.find((grade) => grade.id === gradeId);
  const isTH = currentGrade?.parent_id === 1;

  return (
    !_.isEmpty(sbtBooks) && (
      <div className="result col-12">
        <ResultBook
          data={sbtBooks}
          bookTypeId={BOOK_TYPE_GD_KI_NANG_SO}
          categoryBook="Sách - Gợi ý tổ chức dạy học"
          col={"col-" + (isMobile ? 6  : 2) }
          background="#fff"
        />
      </div>
    )
  );
}
